import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function Offer() {
  const {
    trackAddToCart
  } = useMetaPixel();
  const handleBasicAddToCart = () => {
    trackAddToCart(57, 'BRL');
    window.location.href = 'https://mundo.profepack.com/cart/44076844613715:1';
  };
  const handlePremiumAddToCart = () => {
    trackAddToCart(97, 'BRL');
    window.location.href = 'https://mundo.profepack.com/cart/44076859523155:1';
  };
  return <section id="comprar" className="w-full bg-gray-50 py-8 md:py-20 px-2 md:px-4" data-id="element-89">
      <div className="max-w-6xl mx-auto" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-5 md:mb-16" data-id="element-91">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-2 md:mb-4" data-id="element-92">
            Escolha seu Plano
          </h2>
          <p className="text-base md:text-xl text-gray-600 mb-1 md:mb-2" data-id="element-93">
            Acesso imediato
          </p>
        </motion.div>

        <div className="grid grid-cols-2 lg:grid-cols-2 gap-3 md:gap-8" data-id="element-94">
          {/* PLANO AULAS PRONTAS */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-xl md:rounded-xl shadow-lg overflow-hidden p-3 md:p-8" data-id="element-95">
            <div className="mb-3 md:mb-6" data-id="element-96">
              <div className="text-2xl md:text-3xl mb-2 md:mb-3" data-id="element-97">🛒</div>
              <h3 className="text-sm md:text-2xl font-black text-gray-900 mb-1 md:mb-2 leading-tight" data-id="element-98">
                AULAS PRONTAS
              </h3>
              <p className="text-xs md:text-sm text-gray-600 mb-2 md:mb-4 leading-tight" data-id="element-99">
                Suas aulas resolvidas
              </p>
            </div>

            <div className="mb-3 md:mb-6" data-id="element-100">
              <div className="flex items-center gap-1.5 md:gap-3 mb-1 md:mb-2" data-id="element-101">
                <span className="text-sm md:text-lg text-gray-400 line-through font-bold" data-id="element-102">
                  R$ 197
                </span>
                <span className="bg-green-100 text-green-700 px-1.5 md:px-3 py-0.5 md:py-1 rounded-full text-xs md:text-sm font-bold" data-id="element-103">
                  -71%
                </span>
              </div>
              <div className="text-3xl md:text-5xl font-black text-gray-900" data-id="element-104">
                R$ 57
              </div>
            </div>

            <motion.button onClick={handleBasicAddToCart} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-red-700 text-white px-3 md:px-8 py-2.5 md:py-4 rounded-lg md:rounded-lg font-bold text-sm md:text-lg shadow-lg hover:bg-red-800 transition-all duration-300 mb-2 md:mb-4" data-id="element-105">
              Quero essa
            </motion.button>

            <div className="flex items-center justify-center gap-1 text-gray-500 text-xs md:text-sm mb-3 md:mb-6" data-id="element-106">
              <ShieldCheckIcon className="h-3.5 w-3.5 md:h-5 md:w-5" data-id="element-107" />
              <span className="hidden md:inline" data-id="element-108">🔒 Pagamento seguro</span>
              <span className="md:hidden" data-id="element-109">🔒 Seguro</span>
            </div>

            <div className="border-t border-gray-200 pt-3 md:pt-6" data-id="element-110">
              <h4 className="font-bold text-gray-900 mb-2 md:mb-4 text-xs md:text-sm uppercase" data-id="element-111">
                Inclui:
              </h4>
              <ul className="space-y-1.5 md:space-y-3" data-id="element-112">
                <li className="flex items-start" data-id="element-113">
                  <CheckIcon className="h-3.5 w-3.5 md:h-5 md:w-5 text-green-600 mr-1.5 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-114" />
                  <span className="text-xs md:text-sm text-gray-700 leading-tight" data-id="element-115">
                    12 Tomos PDF
                  </span>
                </li>
                <li className="flex items-start" data-id="element-116">
                  <CheckIcon className="h-3.5 w-3.5 md:h-5 md:w-5 text-green-600 mr-1.5 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-117" />
                  <span className="text-xs md:text-sm text-gray-700 leading-tight" data-id="element-118">
                    Aula em 10min
                  </span>
                </li>
                <li className="flex items-start" data-id="element-119">
                  <CheckIcon className="h-3.5 w-3.5 md:h-5 md:w-5 text-green-600 mr-1.5 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-120" />
                  <span className="text-xs md:text-sm text-gray-700 leading-tight" data-id="element-121">
                    Banco Avaliação
                  </span>
                </li>
                <li className="flex items-start" data-id="element-122">
                  <CheckIcon className="h-3.5 w-3.5 md:h-5 md:w-5 text-green-600 mr-1.5 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-123" />
                  <span className="text-xs md:text-sm text-gray-700 leading-tight" data-id="element-124">
                    Ateliê Econômico
                  </span>
                </li>
                <li className="flex items-start" data-id="element-125">
                  <CheckIcon className="h-3.5 w-3.5 md:h-5 md:w-5 text-green-600 mr-1.5 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-126" />
                  <span className="text-xs md:text-sm text-gray-700 leading-tight" data-id="element-127">
                    Atualizações
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>

          {/* PLANO PROFESSOR ORGANIZADO */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl md:rounded-xl shadow-lg overflow-hidden relative border-2 border-amber-400 p-3 md:p-8" data-id="element-128">
            <div className="absolute top-0 right-0 bg-amber-400 text-amber-900 px-2 md:px-4 py-1 md:py-2 rounded-bl-lg font-black text-xs md:text-sm" data-id="element-129">
              ⭐ TOP
            </div>

            <div className="pt-4 md:pt-6 mb-3 md:mb-6" data-id="element-130">
              <div className="text-2xl md:text-3xl mb-2 md:mb-3" data-id="element-131">🗂️</div>
              <h3 className="text-sm md:text-2xl font-black text-gray-900 mb-1 md:mb-2 leading-tight" data-id="element-132">
                ORGANIZADO
              </h3>
              <p className="text-xs md:text-sm text-gray-600 mb-2 md:mb-4 leading-tight" data-id="element-133">
                Aulas + gestão
              </p>
            </div>

            <div className="mb-3 md:mb-6" data-id="element-134">
              <div className="flex items-center gap-1.5 md:gap-3 mb-1 md:mb-2" data-id="element-135">
                <span className="text-sm md:text-lg text-gray-500 line-through font-bold" data-id="element-136">
                  R$ 297
                </span>
                <span className="bg-green-100 text-green-700 px-1.5 md:px-3 py-0.5 md:py-1 rounded-full text-xs md:text-sm font-bold" data-id="element-137">
                  -67%
                </span>
              </div>
              <div className="text-3xl md:text-5xl font-black text-gray-900" data-id="element-138">
                R$ 97
              </div>
            </div>

            <motion.button onClick={handlePremiumAddToCart} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-gradient-to-r from-amber-600 to-orange-600 text-white px-3 md:px-8 py-2.5 md:py-4 rounded-lg md:rounded-lg font-bold text-sm md:text-lg shadow-lg hover:from-amber-700 hover:to-orange-700 transition-all duration-300 mb-2 md:mb-4" data-id="element-139">
              Quero essa
            </motion.button>

            <div className="flex items-center justify-center gap-1 text-gray-600 text-xs md:text-sm mb-3 md:mb-6" data-id="element-140">
              <ShieldCheckIcon className="h-3.5 w-3.5 md:h-5 md:w-5" data-id="element-141" />
              <span className="hidden md:inline" data-id="element-142">🔒 Pagamento seguro</span>
              <span className="md:hidden" data-id="element-143">🔒 Seguro</span>
            </div>

            <div className="border-t border-amber-200 pt-3 md:pt-6" data-id="element-144">
              <h4 className="font-bold text-gray-900 mb-2 md:mb-4 text-xs md:text-sm uppercase" data-id="element-145">
                Tudo + Mais:
              </h4>
              <ul className="space-y-1.5 md:space-y-3" data-id="element-146">
                <li className="flex items-start" data-id="element-147">
                  <CheckIcon className="h-3.5 w-3.5 md:h-5 md:w-5 text-amber-600 mr-1.5 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-148" />
                  <span className="text-xs md:text-sm text-gray-700 font-medium leading-tight" data-id="element-149">
                    Planejamento Anual
                  </span>
                </li>
                <li className="flex items-start" data-id="element-150">
                  <CheckIcon className="h-3.5 w-3.5 md:h-5 md:w-5 text-amber-600 mr-1.5 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-151" />
                  <span className="text-xs md:text-sm text-gray-700 font-medium leading-tight" data-id="element-152">
                    50 Registros Diário
                  </span>
                </li>
                <li className="flex items-start" data-id="element-153">
                  <CheckIcon className="h-3.5 w-3.5 md:h-5 md:w-5 text-amber-600 mr-1.5 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-154" />
                  <span className="text-xs md:text-sm text-gray-700 font-medium leading-tight" data-id="element-155">
                    Caderno Professor
                  </span>
                </li>
                <li className="flex items-start" data-id="element-156">
                  <CheckIcon className="h-3.5 w-3.5 md:h-5 md:w-5 text-amber-600 mr-1.5 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-157" />
                  <span className="text-xs md:text-sm text-gray-700 font-medium leading-tight" data-id="element-158">
                    Kit Sinalização
                  </span>
                </li>
                <li className="flex items-start" data-id="element-159">
                  <CheckIcon className="h-3.5 w-3.5 md:h-5 md:w-5 text-amber-600 mr-1.5 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-160" />
                  <span className="text-xs md:text-sm text-gray-700 font-medium leading-tight" data-id="element-161">
                    Planejador Eventos
                  </span>
                </li>
                <li className="flex items-start" data-id="element-162">
                  <CheckIcon className="h-3.5 w-3.5 md:h-5 md:w-5 text-amber-600 mr-1.5 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-163" />
                  <span className="text-xs md:text-sm text-gray-700 font-medium leading-tight" data-id="element-164">
                    Modelos Parecer
                  </span>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center mt-3 md:mt-8" data-id="element-165">
          <p className="text-xs md:text-sm text-gray-600" data-id="element-166">
            🛡️ Garantia 7 dias • Acesso imediato
          </p>
        </motion.div>
      </div>
    </section>;
}